<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Internal Quality Assurance Committee</h1>
      <ul>
        <li><a class="active" routerLink="/home">Home</a></li>
        <li>Internal Quality Assurance Committee</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 committee-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <div class="widget-area">
            <div class="widget-archives footer-widget mb-50">
              <h3 class="widget-title">Committees</h3>
              <ul>
                <li class="menu-item-has-children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
                  <ul class="sub-menu">
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/anti-ragging-committee">Anti Ragging Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/grievance-reddressal-committee">Grievance Reddressal Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-complaints-committee">Internal Complaints Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/sc-and-st-grievance-committee">SC &amp; ST Grievance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-quality-assurance-committee">Internal Quality Assurance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/institution-industry-cell">Institution Industry Cell</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="committee-content-wrap">
            <h2 class="committee-main-title">Internal Quality Assurance Committee</h2>

            <h3 class="committee-sub-title">The prime tasks of IQAC</h3>

            <p class="committee-paragraph">
              To develop a system for conscious, consistent and catalytic improvement in the overall performance of
              the institution
            </p>

            <p class="committee-paragraph">
              To channelize all efforts and measures of the institution towards promoting its holistic academic
              excellence
            </p>

            <h3 class="committee-sub-title">Objectives of IQAC</h3>

            <p class="committee-paragraph">
              To ensure continuous improvement in the entire operations of the University
            </p>

            <p class="committee-paragraph">
              To ensure stakeholders connected with higher Education, namely parents, teachers, staff, would be
              employers, funding agencies and society in general, of its own quality and probity.
            </p>

            <p class="blog-table-wrap">
              <a href="/assets/college/Committees/InternalQualityAssuranceCommittee2024-25.pdf" target="_blank">Internal Quality Assurance Committee (click to view)</a>
            </p>

            <h3 class="committee-sub-title">The Functions of IQAC</h3>

            <ol class="function-list">
              <li>Design and implementation of annual plan for institution - level activities for quality enhancement</li>
              <li>Arrange for feedback responses from students for quality - related institutional processes</li>
              <li>Development and Applications of quality bench marks / parameters for the various academic and administrative activities of the institution</li>
              <li>Retrieval of information on various quality parameters of Higher Education and best practices followed by other institutions</li>
              <li>Organizations of Workshops and Seminars on Quality - related themes and promotion of quality circles and institutions- wide dissemination of the proceeding of such activities</li>
              <li>Development and Application of innovative practices in various programmes / activities leading to quality enhancement</li>
              <li>Participation in the creation of learner - centric environment conductive for quality education</li>
              <li>Work for the development of Internationalization and Institutionalization of quality enhancement policies and practices</li>
              <li>Act as a nodal unit of the institution for augmenting quality - related activities</li>
              <li>Prepare focused annual quality assurance report (AQARs)</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

